'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import { NavigationNode } from '@/src/lib/navigation/type';
import { Dictionary } from '@/src/lib/dictionary/types';
import classNames from 'classnames';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export type OffcanvasBreadcrumbsProps = {
  nodes: Array<NavigationNode>;
  dict: Dictionary;
  onClick: (event: React.SyntheticEvent, node: NavigationNode) => void;
  className?: string;
};
function Separator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon name={IconName.CHEVRON_LEFT} className="mx-2 text-base!" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function OffcanvasBreadcrumbs({
  nodes,
  dict,
  onClick,
  className
}: OffcanvasBreadcrumbsProps) {
  nodes = [{
    resourceId: null,
    nodeType: 'link',
    isActive: true,
    title: dict.general.home,
    url: '/'
  }, ...nodes];
  function navigateBack(event: React.SyntheticEvent, nodeIndex: number, isLastNode: boolean) {
    event.preventDefault();
    if (isLastNode) return;
    onClick(event, nodes[nodeIndex + 1]);
  }
  return <ul className={classNames(className, 'flex flex-row flex-wrap items-center')}>
      {nodes.map((node, index) => {
      const isLastNode_0 = index === nodes.length - 1;
      return <li key={node.resourceId ?? node.url} className="flex flex-row">
            <Link href={node.url || ''} onClick={e => navigateBack(e, index, isLastNode_0)} className={isLastNode_0 ? 'no-underline! pointer-events-none' : undefined}>
              {node.title}
            </Link>
            {!isLastNode_0 ? <Separator /> : null}
          </li>;
    })}
    </ul>;
}
export default OffcanvasBreadcrumbs;